import React, { useState, useEffect } from 'react'
import Tabs from '@mui/material/Tabs';
import Box from '@mui/material/Box';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { useMediaQuery } from '@mui/material';
import ProductGridBox from '../ProductCels/ProductGridBox';
import { getProductList } from '../../../networkCalls';
import LoadingProductCell from '../../LoadingCell/LoadingProductCell';
import NoProductFound from '../ProductCels/NoProductFound';
const CategoryDisplayCel = ({ catlist, exportval }) => {
    const state = {
        responsive: {
            0: {
                items: 2,
            },
            450: {
                items: 2,
            },
            600: {
                items: 2,
            },
            1000: {
                items: 4,
            },
        },
    };
    const [value, setValue] = React.useState(0);
    const [loading, setLoading] = React.useState(false);
    const [productData, setProductData] = React.useState([]);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const mediumViewport = useMediaQuery('(min-width:768px)');
    const [activeTab, setActiveTab] = useState(catlist?.[0].id);
    const handleCategory = (value) => {
        setActiveTab(value);
    }
    const callApiProductData = () => {
        var data = new FormData();
        data.append('categoryId', activeTab);
        data.append('all', 'true');
        if (exportval == 'Y') {
            data.append('isExport', exportval);
        }
        setLoading(true);
        getProductList(data).then((res) => {
            setLoading(false);
            switch (res.data.status) {
                case 1:
                    setProductData(res.data?.ProductList);
                    return true;
                case 0:

                    break;
                default:
                    return;
            }
        })
    }
    useEffect(() => {
        callApiProductData();
    }, [activeTab]);
    return (
        <>
            <div className='container'>
                <div className='row'>
                    <div className='col-lg-2 col-md-4 pe-0'>
                        <Box
                            sx={{ display: { xs: '', sm: 'flex' }, height: { xs: '', sm: 380, md: 380, lg: 430 }, bgcolor: 'background.paper', flexGrow: 1 }}
                        //  sx={{ flexGrow: 1, , display: 'flex', height: 430}}
                        //  sx={{ bgcolor: 'background.paper' }}
                        >
                            <Tabs
                                value={value}
                                //orientation="vertical"
                                variant='scrollable'
                                scrollButtons="auto"
                                allowScrollButtonsMobile
                                //indicatorColor='secondary'
                                orientation={mediumViewport ? "vertical" : "horizontal"}
                                onChange={handleChange}
                                className="mt-2"
                                TabIndicatorProps={{
                                    style: {
                                        display: "none",
                                    },
                                }}
                            >
                                {catlist?.map((data, i) => (
                                    <div key={i} className={`btn col-md-12 col-9 border shadow-sm me-lg-0 me-3 mb-3 ${activeTab == data?.id ? 'redborder' : ''}`} onClick={() => { handleCategory(data?.id) }}>
                                        <div className='d-flex align-items-center'>
                                            <div className='text-center'>
                                                <img src={data?.image} alt={data?.name} style={{ width: '50px' }} />
                                            </div>
                                            <div className='ps-2 text-start text-wrap'>
                                                <div className='fw-bold f12'>{data?.name}</div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </Tabs>
                        </Box>
                    </div>
                    <div className='col-lg-10 col-md-8'>
                        {loading ? <>
                            <div className="row">
                                {Array.apply(null, { length: 4 }).map((e, i) => (
                                    <div className='col-lg-3 col-md-4 col-6 mb-3' key={i}>
                                        <LoadingProductCell />
                                    </div>
                                ))}
                            </div></> : <>
                            {productData && productData?.length > 0 ? <>
                                <OwlCarousel className='owl-theme with-nav-bottom-center' autoplay={false} items={4} nav={true} dots={false} responsive={state.responsive}>
                                    {productData && productData?.length > 0 && productData?.map((itemin, key) => (
                                        <div className="p-2" key={key}>
                                            <ProductGridBox itemin={itemin} />
                                        </div>
                                    ))}
                                </OwlCarousel>
                            </> :
                                <><NoProductFound /></>
                            }
                        </>}
                    </div>
                </div>
            </div>
        </>
    )
}

export default CategoryDisplayCel